var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7929 6.79289C13.4024 7.18342 13.4024 7.81658 13.7929 8.20711L16.5858 11H5C4.44771 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13H16.5858L13.7929 15.7929C13.4024 16.1834 13.4024 16.8166 13.7929 17.2071C14.1834 17.5976 14.8166 17.5976 15.2071 17.2071L19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929L15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4a6eb30c.svg";
export { ForwardRef as ReactComponent };